import { render, staticRenderFns } from "./cursos-test.vue?vue&type=template&id=5a47eef9&"
import script from "./cursos-test.vue?vue&type=script&lang=js&"
export * from "./cursos-test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports